/***
 * Access Token & User Cookies
 * @type {string}
 */
const cookieAuth = "admin-session"
const cookieData = "admin"
const cookieRefresh = "admin-refresh"

export {cookieData,cookieAuth,cookieRefresh}